import React from 'react';

interface PanelProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  tools?: React.ReactNode;
}

export const Panel: React.FC<PanelProps> = ({ children, className = '', title, tools }) => {
  return (
    <div className={`bg-dark-surface/90 backdrop-blur-sm border border-dark-border/30 rounded-xl shadow-sm flex flex-col ${className}`}>
      {(title || tools) && (
        <div className="flex items-center justify-between px-4 py-2 border-b border-dark-border/30 bg-gradient-to-r from-dark-surface/60 to-transparent shrink-0 rounded-t-xl">
          {title && <h3 className="text-xs font-bold text-white/80 uppercase tracking-wider">{title}</h3>}
          {tools && <div className="flex items-center space-x-2">{tools}</div>}
        </div>
      )}
      <div className="flex-1 overflow-hidden relative flex flex-col">
        {children}
      </div>
    </div>
  );
};
